<template>
  <div :style="{ width: displayInline ? 'fit-content' : '100%', display: displayInline ? 'inline' : 'block' }">
    <Field v-slot="{ field }" v-model="mutatedValue" :label="label" :name="name" :rules="validation">
      <div class="basic-checkbox-input-container">
        <input :id="name" :ref="name" type="checkbox" :model-value="field.value" :checked="field.value" v-bind="field"
          :disabled="(typeof checkboxChildrenValue == 'boolean' && !checkboxChildrenValue) || isReadOnly"
          @change="[(mutatedValue = $event.target.checked), onChange()]">
        <label :for="name">{{ placeholder }}</label>
      </div>
      <ErrorMessage class="error-msg" :name="name" />
    </Field>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus'
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * label: label displayed (string),
 * name: input name (string)
 * value: if the checkbox is checked or not (Boolean)
 */
export default {
  name: 'BasicCheckbox',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    defaultValue: [Boolean, Array],
    name: String,
    displayInline: Boolean,
    onlyOneSelected: {
      type: Boolean,
      default: false
    },
    checkboxChildrenValue: {
      type: [Boolean, Object]
    },
    checkBoxUniq: {
      type: Object,
      default: null
    },
    mainName: {
      type: String,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addData', 'onlyOneSelectedName'],
  data() {
    return {
      mutatedValue: this.defaultValue ? this.defaultValue : false
    }
  },
  computed: {
    fieldMultipleDiff() {
      return this.checkBoxUniq[this.mainName] !== this.name
    }
  },
  watch: {
    mutatedValue() {
      EventBus.emit('onCheckboxClicked', { name: this.name, value: this.mutatedValue })
    },
    fieldMultipleDiff() {
      if (this.fieldMultipleDiff) {
        this.mutatedValue = false
        this.$emit('addData', { value: false, name: this.name })
      }
    },
    checkboxChildrenValue() {
      if (!this.checkboxChildrenValue) {
        this.mutatedValue = false
        this.$emit('addData', { value: false, name: this.name })
      }
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: false, name: this.name })
  },
  methods: {
    onChange(e) {
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
      if (this.onlyOneSelected) {
        if (e.target.checked) {
          this.$emit('onlyOneSelectedName', { mainName: this.mainName, name: this.name })
        } else {
          this.$emit('onlyOneSelectedName', { mainName: this.mainName, name: null })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-checkbox-input-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 10px 10px 0;

  input {
    border-radius: 0;
    position: relative;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-right: 8px;
    border: 1px black solid;
    min-height: 1rem;
    min-width: 1rem;
    background-color: transparent;
    transition: 0.3s;
    cursor: pointer;

    @media only screen and (width >=768px) {
      min-height: 1.5rem;
      min-width: 1.5rem;
    }

    /* Desktops and laptops */
    @media only screen and (width >=1024px) {
      min-height: 1.5rem;
      min-width: 1.5rem;
    }

    /* Large screens */
    @media only screen and (width >=1824px) {
      min-height: 1.75rem;
      min-width: 1.75rem;
    }
  }

  input:checked,
  input:checked:disabled {
    background-color: black;
    transition: 0.3s;
  }

  input:disabled {
    background-color: rgb(189 189 189);
  }
}
</style>
